'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';

import { readRegimeCookie } from '@/lib/consent-regime';

/**
 * CPRA "Do Not Sell or Share" footer link, shown only to visitors in the
 * 'ccpa' regime. Reads the middleware-set regime cookie client-side so the
 * Footer (and every page embedding it) stays statically cacheable.
 */
export function DoNotSellFooterLink(): React.JSX.Element | null {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(readRegimeCookie() === 'ccpa');
  }, []);
  if (!show) return null;
  return (
    <Link
      href="/legal/do-not-sell"
      data-analytics-cta="footer_dnsmpi"
      data-analytics-location="footer"
      className="text-[14px] font-light text-accent underline-offset-2 transition-colors hover:underline lg:text-[15px]"
    >
      Do Not Sell or Share My Personal Information
    </Link>
  );
}
